<template>
  <div class="form-item">
    <div
      class="form-item-label"
      :class="{ 'form-item-label-focus': labelFocus }"
    >
      验证码
    </div>
    <div class="form-item-content">
      <input
        type="tel"
        @focusin="handleFocusin"
        @focusout="handleFocusout"
        :value="code"
        @input="handleInput"
      />
      <div v-if="sending" class="form-item-code form-item-code-sending">
        重新发送 <span>{{ wait }}</span> 秒
      </div>
      <div
        v-else
        class="form-item-code"
        :class="{ 'form-item-code-active': active }"
        @click="handleSendCode"
      >
        获取验证码
      </div>
      <div>
        <div class="input-line"></div>
        <div
          class="input-focus-line"
          :class="{ 'input-focus-line-active': focus }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPhoneCode } from "@/api/login";

export default {
  name: "CodeInput",
  computed: {
    labelFocus() {
      const code = this.code;
      return this.focus || (code !== null && code.length > 0);
    }
  },
  props: {
    code: {
      type: String,
      default: ""
    },
    active: {
      type: Boolean,
      default: false
    },
    phone: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      focus: false,
      sending: false,
      wait: 60,
      timer: null
    };
  },
  methods: {
    handleFocusin() {
      this.focus = true;
    },
    handleFocusout() {
      this.focus = false;
    },
    handleInput(event) {
      const value = event.target.value.slice(0, 6);
      // 修改state
      this.$emit("update:code", value);
      // 修改视图
      event.target.value = value;
      if (value.length === 6) {
        this.$emit("validate", true);
      } else {
        this.$emit("validate", false);
      }
    },
    async handleSendCode() {
      if (this.sending || !this.active) return;
      const result = await this.sendCode();
      if (result) {
        this.sending = true;
        this.countDown();
      } else {
        console.error("错误提示");
      }
    },
    countDown() {
      this.timer = setInterval(() => {
        this.wait--;
        if (this.wait === 0) {
          this.sending = false;
          this.wait = 60;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    async sendCode() {
      try {
        await getPhoneCode(this.phone);
        return true;
      } catch (e) {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-item {
  position: relative;
  text-align: left;
  width: 100%;
  .form-item-label {
    height: 18px;
    position: relative;
    top: 18px;
    font-size: 16px;
    font-weight: 400;
    color: rgba(200, 202, 216, 1);
    line-height: 50px;
    z-index: 2;
    transition: all 0.4s ease 0s;
  }
  .form-item-label-focus {
    top: 0;
    font-size: 13px;
    line-height: 18px;
    color: rgba(228, 191, 88, 1);
    font-weight: 500;
  }

  .form-item-content {
    position: relative;
    margin-bottom: 41px;
    height: 50px;
    width: 100%;
    input {
      outline: none;
      height: 100%;
      width: 100%;
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .form-item-code {
      position: absolute;
      right: 0;
      bottom: 2px;
      width: 120px;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-weight: 400;
      color: #c8cad8;
      text-align: right;
      z-index: 10;
    }
    .form-item-code-active {
      color: rgba(228, 191, 88, 1);
    }
    .form-item-code-sending {
      text-align: right;
      width: 120px;
      color: #c8cad8;
      span {
        color: rgba(228, 191, 88, 1);
      }
    }
    .input-line {
      position: absolute;
      bottom: -1px;
      width: 100%;
      height: 1px;
      background: rgba(198, 206, 215, 1);
    }
    .input-focus-line {
      position: absolute;
      left: 50%;
      bottom: -1px;
      width: 0;
      height: 2px;
      background: rgba(0, 0, 0, 0.54);
      transition: all 0.4s ease 0s;
    }
    .input-focus-line-active {
      background: rgba(228, 191, 88, 1);
      left: 0;
      width: 100%;
    }
  }
}
</style>
